var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1080,
    viewBox: "0 0 1080 1080",
    width: 1080,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    height: 787,
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    width: 787,
    x: 144,
    y: 146
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#C4C4C4",
    height: 760,
    rx: 136.5,
    stroke: "url(#paint0_linear)",
    strokeWidth: 27,
    width: 760,
    x: 157.5,
    y: 159.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.55 513.85H463.3V473C463.3 441.967 467.1 416.95 474.7 397.95C482.3 378.317 492.433 363.433 505.1 353.3C517.767 342.533 532.017 335.567 547.85 332.4C564.317 328.6 581.417 326.7 599.15 326.7C633.983 326.7 659.317 328.917 675.15 333.35V417.9C668.183 416 660.583 414.733 652.35 414.1C644.75 412.833 635.567 412.2 624.8 412.2C610.233 412.2 597.567 415.683 586.8 422.65C576.667 429.617 571.6 443.233 571.6 463.5V513.85H663.75V594.6H571.6V1005H463.3V594.6H382.55V513.85Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 760,
    rx: 136.5,
    stroke: "url(#paint2_linear)",
    strokeWidth: 27,
    width: 760,
    x: 157.5,
    y: 159.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear",
    x1: 538,
    x2: 534.011,
    y1: 146,
    y2: 932.98
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1778F2",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1778F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear",
    x1: 485,
    x2: 485,
    y1: 116.921,
    y2: 1056.99
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1979F2",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7AF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint2_linear",
    x1: 538,
    x2: 534.011,
    y1: 146,
    y2: 932.98
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1778F2",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1778F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial2);
export default __webpack_public_path__ + "static/media/social2.3bfdd71dfd24d2639095e77a58457b66.svg";
export { ForwardRef as ReactComponent };